import { useMemo } from 'react';
import { resolveSearchConfigSections, TDR } from 'tdr-common';
import { SearchFilters } from '../routes/AvailabilityGuard';
import { useLinkKey } from './useLinkKey';

/** Section list for the results screen, resolved from the restaurant's searchConfig rules. */
export function useResolvedSearchConfig(
	restaurant: TDR.Restaurant,
	searchFilters: Partial<SearchFilters>
): TDR.SearchConfig.Section[] {
	const linkKey = useLinkKey(restaurant?.id);

	return useMemo(() => {
		return resolveSearchConfigSections(restaurant, {
			groupSize: searchFilters.groupSize,
			date: searchFilters.date,
			time: searchFilters.time,
			linkKey
		});
	}, [restaurant, searchFilters.groupSize, searchFilters.date, searchFilters.time, linkKey]);
}
